export default __webpack_public_path__ + "static/intro-comics-ce31f51553e5cb1100e781de965eb49c.pdf";